import { render } from "./dashboard-final.vue?vue&type=template&id=24c8fae7"
import script from "./dashboard-final.vue?vue&type=script&lang=js"
export * from "./dashboard-final.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__